import type { ReactNode } from "react";

export type StepKey = "form" | "triage" | "result";
export type Flow = "eng" | "incident";

const STEPS: { key: StepKey; title: string; desc: string }[] = [
  { key: "form", title: "Raise an engineering ticket", desc: "Same fields as the Slack form" },
  { key: "triage", title: "AI triage", desc: "Checked before anyone's paged" },
  { key: "result", title: "Result", desc: "Ticket created, or you're told why not" },
];

// An incident skips triage, so the middle step is the creation of everything.
const INCIDENT_STEPS: typeof STEPS = STEPS.map((item) =>
  item.key === "triage"
    ? { ...item, title: "Create", desc: "Posted to Slack, channel and Jira ticket created" }
    : item.key === "form"
      ? { ...item, title: "Report an incident" }
      : item,
);

function stateOf(step: StepKey, current: StepKey): "done" | "current" | "upcoming" {
  const order = STEPS.map((item) => item.key);
  const a = order.indexOf(step);
  const b = order.indexOf(current);
  return a < b ? "done" : a === b ? "current" : "upcoming";
}

// The left-hand progress rail and the panel, as laid out in the prototype.
export function Workspace({ step, flow = "eng", children }: { step: StepKey; flow?: Flow; children: ReactNode }) {
  return (
    <main className="layout">
      <aside className="rail" aria-label="Progress">
        <ol className="steps">
          {(flow === "incident" ? INCIDENT_STEPS : STEPS).map((item, index) => (
            <li key={item.key} className="step" data-state={stateOf(item.key, step)}>
              <span className="step-index">{index + 1}</span>
              <div>
                <span className="step-title">{item.title}</span>
                <span className="step-desc">{item.desc}</span>
              </div>
            </li>
          ))}
        </ol>
      </aside>
      <section className="panel">{children}</section>
    </main>
  );
}

export const WidePanel = ({ children }: { children: ReactNode }) => (
  <main>
    <section className="panel">{children}</section>
  </main>
);
